import { Box, Chip, Grid, Pagination, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Link, useNavigate } from 'react-router-dom';
import AlphabetHeader from '../componentes/AlphabetHeader';
import mobile from '../lib/mobile';
import estados from '../lib/estados';
import { limpiarTexto } from '../lib/format';
const ListadoEmpresas = ({ busqueda = '', estado = '', actividad = '' }) => {
    const [empresas, setEmpresas] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    const [catalogoActividades, setCatalogoActividades] = useState([]);
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    const [data, setData] = useState(null);
    const getCatalogoActividades = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`)
            .then((res) => res.json())
            .then((respuesta) => {
                setCatalogoActividades(respuesta.data);
            })
    }
    const getCatalogoFiguras = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_es`)
            .then(res => res.json())
            .then((respuesta) => {
                setCatalogoFiguras(respuesta.data);
            });
    }

    //! Fltrados
    // realizar busqueda
    // useEffect(() => {
    //     if (busqueda === '') {
    //         init();
    //     } else {
    //         let newEmpresas = empresas.filter(
    //             (empresa) => empresa.nombre.toLowerCase().includes(busqueda.toLowerCase()) || empresa.nombre_comercial.toLowerCase().includes(busqueda.toLowerCase())
    //         );
    //         setFilteredRows(newEmpresas);
    //     }
    //     //setEmpresas()
    // }, [busqueda]);

    // useEffect(() => {
    //     if (!estado) {
    //         init();
    //     } else {
    //         let newEmpresas = empresas.filter((empresa) => limpiarTexto(empresa.estado.toLowerCase()) == limpiarTexto(estado.toLowerCase()));
    //         setFilteredRows(newEmpresas);
    //     }
    // }, [estado]);

    // useEffect(() => {
    //     // console.log(empresas);
    //     // console.log(data);
    //     if (!actividad) {
    //         init();
    //     } else {
    //         let newEmpresas = empresas.filter((empresa) => {
    //             if (empresa.giros_actividad) {
    //                 let actividades = empresa.giros_actividad.split(', ');
    //                 actividades.map((act) => console.log(act));
    //                 console.log("ACT " + actividad.codigo_act);
    //                 return actividades.includes(actividad.codigo_act);
    //             } else {
    //                 return false;
    //             }
    //         });
    //         setFilteredRows(newEmpresas);
    //     }
    // }, [actividad]);
    useEffect(() => {

        // Función que realiza el filtrado considerando las tres condiciones
        const filtrarEmpresas = () => {
            let newEmpresas = empresas.filter((empresa) => {
                const cumpleBusqueda =
                    busqueda === '' ||
                    empresa.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
                    empresa.nombre_comercial.toLowerCase().includes(busqueda.toLowerCase());

                const cumpleEstado =
                    !estado || limpiarTexto(empresa.estado.toLowerCase()) === limpiarTexto(estado.toLowerCase());

                const cumpleActividad =
                    !actividad ||
                    (empresa.giros_actividad && empresa.giros_actividad.split(', ').includes(actividad.codigo_act));

                // La empresa debe cumplir todas las condiciones para ser incluida
                return cumpleBusqueda && cumpleEstado && cumpleActividad;
            });

            setFilteredRows(newEmpresas);
        };

        // Llama a la función de filtrado
        filtrarEmpresas();
    }, [busqueda, estado, actividad, empresas]);


    //! endFiltrados


    const init = async () => {
        try {
            await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/empresas?page=${page}`)
                .then(res => res.json())
                .then((respuesta) => {
                    setData(respuesta.data);
                    setEmpresas(respuesta.data.empresas_completas);
                    setFilteredRows(respuesta.data.empresas);
                });
        } catch (error) {
            //console.log(error);
            //alert(error);
        }
    }

    useEffect(() => {
        init();
        getCatalogoActividades();
        getCatalogoFiguras();
        setIsMobile(mobile());
    }, []);
    const columns = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 250, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        {/* <Typography variant="body1" noWrap>{params.row.descripcion}</Typography> */}
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.localidad}, {empresa.municipio}, {empresa.estado}</Typography>
                        {/* <Link to={`/empresas/${empresa.nombre}`}> */}
                        <Typography sx={{ mt: 6, "& :hover": { cursor: 'pointer' } }} color="#404555">{'Detalle >'}</Typography>
                        {/* </Link> */}
                    </Box>
                )
            }
        },
        // para indicar si la empresa es una vista preliminar
        {
            headerHeight: 0,
            field: 'status',
            headerName: '',
            width: 135,
            renderCell: (params) => {
                return (
                    <Box>
                        {
                            params.row.status == 0 ?
                                <Chip label={'Vista preliminar'} color={'warning'} />
                                :
                                <></>
                        }
                    </Box>
                )
            }

        }

    ]

    const columnsSmall = [
        {
            headerHeight: 0,
            field: 'id', headerName: '', width: 100, renderCell: (params) => {
                //console.log(params)
                return (
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                        <img style={{ objectFit: 'contain', width: '100%', height: '100%' }} src={params.row.logotipo} alt="logotipo" />
                    </Box>
                )
            }
        },
        {
            headerHeight: 0,
            field: 'nombre', headerName: '', flex: 1, renderCell: (params) => {
                //console.log(params.row);
                let empresa = params.row;
                return (
                    <Box sx={{ alignItems: 'start', cursor: 'pointer', width: '100%' }}>
                        <Typography sx={{ my: 1 }} variant="body1" noWrap><strong>{empresa.nombre}</strong> ({empresa.acronimo})</Typography>
                        <Typography sx={{ my: 1 }} color="#a0a0a0">{empresa.municipio}, {empresa.estado}</Typography>
                    </Box>
                )
            }
        }
    ]
    const handleLetterClick = (filteredRows) => {
        setFilteredRows(filteredRows);
    };
    // para la paginacion
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const handleChangePage = (e, v) => setPage(v);
    useEffect(() => {
        const get = async () => {
            const url = `https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/empresas?page=${page}`;
            await fetch(url)
                .then((res) => res.json())
                .then((respuesta) => {
                    //setEmpresas(respuesta.data.empresas);
                    setFilteredRows(respuesta.data.empresas);
                    setTotalPages(respuesta.data.cant_paginas);
                });
        }
        get();
    }, [page]);
    return (
        <Box sx={{ m: 2 }}>
            {/* En celular, mostrar  un boton para ir a https://https://empresas-economiasocialysolidaria.com.mx/ */}



            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <AlphabetHeader rows={empresas} onLetterClick={handleLetterClick} />
                <DataGrid
                    rowHeight={150}
                    columns={columns}
                    rows={filteredRows}
                    onRowClick={(params) => {
                        // envair a https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/nombre-empresa
                        let t = params.row.nombre_comercial.toLowerCase()
                        t = t.split(' ').join('-')
                        let nombre = limpiarTexto(t);
                        // alert("diste click")
                        window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');

                        //navigate(`/empresas/${params.row.nombre}`);
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
                <DataGrid
                    rowHeight={100}
                    columns={columnsSmall}
                    rows={filteredRows}
                    onRowClick={(params) => {
                        let t = params.row.nombre_comercial.toLowerCase()
                        t = t.split(' ').join('-')
                        let nombre = limpiarTexto(t);
                        
                        if (!isMobile) {
                            window.open(`https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`, '_blank');
                        } else {
                            window.location.href = `https://empresas-economiasocialysolidaria.com.mx/perfiles-empresariales/${nombre}`;
                        }
                    }}
                    slots={
                        {
                            footer: () => { },
                            //header: () => { }
                        }
                    }
                    columnHeaderHeight={0}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                <Pagination count={totalPages} page={page} onChange={handleChangePage} />
            </Box>
        </Box>
    )
}

export default ListadoEmpresas